import { ParentAssigner, Root } from "../parent-assigner.js";

class ParentMultiAssigner extends ParentAssigner {
    constructor(assigners) {
        super();
        this._assigners = Object.assign({}, assigners);
    }

    link(parent, child) {
        for (const key in this._assigners) {
            this._assigners[key].link(parent === Root ? Root : parent.objects[key], child.objects[key]);
        }
    }

    unlink(parent, child) {
        for (const key in this._assigners) {
            this._assigners[key].unlink(parent === Root ? Root : parent.objects[key], child.objects[key]);
        }
    }
}

export default ParentMultiAssigner;
